<mat-divider></mat-divider>
<nav class="pages-nav">
  @for (page of pages$ | async; track page.id) {
    <span class="page-link">
      <a matButton="outlined" routerLink="/page/{{ page.id }}" routerLinkActive="active">
        @if (page.icon; as icon) {
          <mat-icon>{{ icon }}</mat-icon>
        }
        {{ page.title }}
      </a>

      @if (isEditor$ | async) {
        <span class="u-center m-0 px-3">
          @if (page.hidden) {
            <button mat-icon-button disabled class="small-icon-btn">
              <mat-icon inline class="visbility-icon">visibility_off</mat-icon>
            </button>
          }
          <a mat-icon-button [routerLink]="['/editor', page.id]" (click)="$event.stopPropagation()" class="small-icon-btn">
            <mat-icon inline color="warn">edit</mat-icon>
          </a>
        </span>
      }
    </span>
  }
</nav>
